import { render, staticRenderFns } from "./StaffPanel.vue?vue&type=template&id=6c88d4ae&scoped=true"
import script from "./StaffPanel.vue?vue&type=script&lang=js"
export * from "./StaffPanel.vue?vue&type=script&lang=js"
import style0 from "./StaffPanel.vue?vue&type=style&index=0&id=6c88d4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c88d4ae",
  null
  
)

export default component.exports